// extracted by mini-css-extract-plugin
module.exports = {"title":"style_title__3PSep","terms":"style_terms__3Vn0M"};